import * as LucideIcons from 'lucide-react';
import { HelpCircle } from 'lucide-react';

// Define props for our Icon component
interface IconProps {
  name: string;
  size?: number;
  color?: string;
  className?: string;
  strokeWidth?: number;
  [key: string]: unknown;
}

function Icon({
  name,
  size = 24,
  color = 'currentColor',
  className = '',
  strokeWidth = 2,
  ...props
}: IconProps): JSX.Element {
  // Use a safer approach to determine if the icon exists
  // and dynamically render it

  try {
    // Convert kebab-case to PascalCase
    const toPascalCase = (str: string): string => {
      return str
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');
    };

    const pascalName = toPascalCase(name);

    // Check if the icon exists in LucideIcons
    const iconExists = Object.prototype.hasOwnProperty.call(LucideIcons, pascalName);

    if (iconExists) {
      // This is a bit of a TypeScript hack, but it works because we know the icon exists
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const DynamicIcon = (LucideIcons as any)[pascalName];
      return <DynamicIcon size={size} color={color} strokeWidth={strokeWidth} className={className} {...props} />;
    }
  } catch {
    // Icon not found, fallback to HelpCircle
  }

  // Default to HelpCircle as fallback
  return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
}
export default Icon;
